// extracted by extract-css-chunks-webpack-plugin
module.exports = {"company":"company_2+aRd","illus":"illus_VU3LA","title":"title_IyGpu","bar":"bar_xyK1I","bar_wrap":"bar_wrap_d3+FQ","desc":"desc_zLm+O","desc_wrap":"desc_wrap_SkHo2"};